import envioContabilidadeApi from "./api";
import menu from "./menu";
import routes from "./routes";
import EnvioContabilidadeIndex from "./pages/Index.vue";

export { envioContabilidadeApi, menu, routes, EnvioContabilidadeIndex };

export default routes;
